import { group } from "@angular/animations";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { VisibilityService } from "@services/visibility.service";
import { ActivatedRoute } from "@angular/router";
import { DomainConfigComponent } from "@app/domain-config.component";
import { PjudIndicatorsAccessService } from "@app/pjud-indicators/pjud-indicators-access.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { grupoAbiertoTrasPulsar } from "./sidebar.logic";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  visibilities = [];
  visibilityGroupIdActived = 0;
  showMyRequirementsVisibilities: boolean;
  parametrosUrl: any = [];
  isUrlParams: boolean = false;

  visibilityGroupId: number;
  visibilityId: number;

  @Output() pending = new EventEmitter();
  @Output() visibilityIdSelected = new EventEmitter();
  @Output() showMyRequirementsActived = new EventEmitter<boolean>();
  @Input() visiData: Array<any>;
  @Input() activitiesBadget: number;

  visibilityIdActive: number = null;
  showCalendarOption: boolean = false;
  showPjudIndicatorsOption = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    public _visibility: VisibilityService,
    private activeRoute: ActivatedRoute,
    public domainConfigComponent: DomainConfigComponent,
    private pjudIndicatorsAccess: PjudIndicatorsAccessService,
    private cdr: ChangeDetectorRef,
  ) {
    // Verificar si se debe mostrar la opción del calendario
    this.showCalendarOption = this.domainConfigComponent.configCalendar;
  }

  ngOnInit() {
    this.pjudIndicatorsAccess.canAccess()
      .pipe(takeUntil(this.destroy$))
      .subscribe((allowed) => {
        this.showPjudIndicatorsOption = allowed;
        this.cdr.markForCheck();
      });

    this.activeRoute.params.subscribe((params) => {
      console.log('ngOnInit sidebar');
      this.visibilityGroupId = parseInt(params["visibilityGroupId"]);
      this.visibilityId = parseInt(params["visibilityId"]);

      if (JSON.stringify(params) !== "{}") {
        this.isUrlParams = true;
      } else {
        this.isUrlParams = false;
      }
      this.showMyRequirementsVisibilities = false;
      this.loadVisibilities();
    });
  }

  showMyRequirements(value) {

    if (value) this.showMyRequirementsVisibilities = true;
    else this.showMyRequirementsVisibilities = false;

    this.loadVisibilities();

    this.showMyRequirementsActived.emit(value);
  }

  loadVisibilities() {

    const body = {
      myRequirements: this.showMyRequirementsVisibilities,
    };
    this._visibility.getVisibility(body).subscribe((data) => {

      const raw = data?.result ?? data;
      this.visibilities = Array.isArray(raw) ? raw : [];

      if (!this.visibilities.length) {
        this.pending.emit(null);
        return;
      }

      const pending = this.visibilities.find(
        (visibility) => visibility.name === "Pendientes"
      );
      this.visibilities = this.visibilities.filter(
        (visibility) => visibility.name !== "Pendientes"
      );
      this.visibilities.map((x) => {
        x.show = false;
      });
      if(!this.domainConfigComponent.configMyActivities && this.visibilities[0]){
        this.visibilities[0].show = true;
      }

      this.pending.emit(
        pending ? pending.items?.[0] : this.visibilities[0]?.items?.[0]
      );
      let visibilityIdReq = null;
      console.log('isUrlParams', this.isUrlParams);
      if (this.isUrlParams) {
        let visibility = this.visibilities.find(
          (i) => i.id === this.visibilityGroupId
        );
        let status = visibility?.items?.find(
          (item: any) => item.id == this.visibilityId
        );

        if (visibility && status) {
          let objReturn = {
            tipo: visibility.id,
            estado: status.id,
          };

          this.visibilityGroupIdActived = objReturn.tipo;
          visibilityIdReq = objReturn.estado;
        }
      } else {
        if(!this.domainConfigComponent.configMyActivities && this.visibilities[0]?.items?.[0]){
          this.visibilityGroupIdActived = this.visibilities[0].id;
          visibilityIdReq = this.visibilities[0].items[0].id;
        }else{
          this.visibilityGroupIdActived = 0;
          visibilityIdReq = 0;
        }

      }

      const menuIdVisibility = localStorage.getItem("id_visibility_req_menu");
      if (menuIdVisibility) {
        this.showMenu(+menuIdVisibility, true);
      }
    });
  }
  showMenu(id, soloAbrir = false) {

    let group_ = null;
    console.log('visibilityGroupIdActived', this.visibilityGroupIdActived);
    console.log('visibilityGroupId', id);
    if(this.visibilityGroupIdActived != 0 && this.visibilityGroupIdActived != id){
      localStorage.removeItem("requirement_list_page");
    }
    this.visibilityGroupIdActived = grupoAbiertoTrasPulsar(this.visibilityGroupIdActived, id, soloAbrir);
    if (this.visibilityGroupIdActived !== null) {
      console.log('showMenu sidebar');

      localStorage.setItem("id_visibility_req_menu", id);
      group_ = this.visibilities.filter((visibility) => visibility.id == id);
      if (!group_?.length || !group_[0]?.items?.length) {
        return;
      }
      let first_item_id = group_[0].items[0].id;
      const oldVisibilityId = +localStorage.getItem(
        "visibility_requirement_list"
      );

      if(oldVisibilityId && group_[0].items.find((item)=> item.id == oldVisibilityId)){
        this.sendVisibilityId(oldVisibilityId);
      }else{
        localStorage.removeItem("requirement_list_page");
        this.sendVisibilityId(first_item_id);
      }
    }
  }
  getSectionBadge(section) {
    return section["items"].reduce(
      (total: Number, item: Object) =>
        item["allowCount"] ? total + item["count"] : total,
      0
    );
  }

  sendVisibilityId(id) {

    if(this.visibilityIdActive && this.visibilityIdActive !=0 && this.visibilityIdActive != +id){
      localStorage.removeItem("requirement_list_page");
    }
    this.visibilityIdActive = +id;
    localStorage.setItem("visibility_requirement_list", id);
    let sendVisibilityIdObj = {
      visibilityGroup: this.visibilityGroupIdActived,
      visibilityId: id,
    };
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }


  showActivities(){
    localStorage.removeItem('id_visibility_req_menu');
    localStorage.removeItem('visibility_requirement_list');
    localStorage.removeItem('requirement_list_page');
    let sendVisibilityIdObj = {
      visibilityGroup: 0,
      visibilityId: 0,
    };
    this.visibilityGroupIdActived = 0;
    this.visibilityIdActive = 0;
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }

  showCalendar(){
    localStorage.removeItem('id_visibility_req_menu');
    localStorage.removeItem('visibility_requirement_list');
    localStorage.removeItem('requirement_list_page');
    let sendVisibilityIdObj = {
      visibilityGroup: -1,
      visibilityId: -1,
    };
    this.visibilityGroupIdActived = -1;
    this.visibilityIdActive = -1;
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Vuelve a traer conteos del menú de flujos (Equipo/Propios) sin resetear
   * la sección expandida ni reemitir el flujo seleccionado. Útil tras eliminar
   * o carga masiva, cuando la grilla se refresca pero el árbol quedaba desactualizado.
   */
  refreshFlowCounts(): void {
    const body = {
      myRequirements: this.showMyRequirementsVisibilities,
    };
    this._visibility.getVisibility(body).subscribe((data) => {
      const all = Array.isArray(data?.result) ? data.result : Array.isArray(data) ? data : [];
      if (!all.length) {
        return;
      }
      const pending = all.find((v) => v.name === "Pendientes");
      this.visibilities = all.filter((v) => v.name !== "Pendientes");
      this.visibilities.forEach((x) => {
        if (x.show === undefined) {
          x.show = false;
        }
      });
      this.pending.emit(
        pending
          ? pending.items?.[0]
          : this.visibilities[0]?.items?.[0]
      );
    });
  }

}
